import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { getDisplayName } from '@material-ui/utils';
import { withTheme } from '@material-ui/core/styles';
/**
 * @param {string} name
 * @param {{ withTheme: boolean }} options
 */

var withThemeProps = function withThemeProps(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (WrappedComponent) {
    var WithThemeProps = React.forwardRef(function WithThemeProps(props, ref) {
      /**
       * @type {{ theme: import('./types').EcrionTheme }}
       */
      var theme = props.theme,
          rest = _objectWithoutProperties(props, ["theme"]);

      var more = {};

      if (typeof name === 'string') {
        var propOverrides = theme.getProps(name);
        Object.keys(propOverrides).map(function (propOverride) {
          if (typeof rest[propOverride] === 'undefined') {
            //not specified, use theme value
            more[propOverride] = propOverrides[propOverride];
          }
        });
      }

      if (options.withTheme) more.theme = theme;
      return React.createElement(WrappedComponent, Object.assign({
        ref: ref
      }, rest, more));
    });

    if (process.env.NODE_ENV !== 'production') {
      WithThemeProps.displayName = "WithThemeProps(".concat(getDisplayName(WrappedComponent), ")");
    }

    return withTheme(WithThemeProps);
  };
};

export default withThemeProps;